(function(){
var SVG="<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.3' stroke-linecap='round' stroke-linejoin='round'><circle cx='12' cy='8' r='3.4'></circle><path d='M5 20c0-3.6 3.1-5.6 7-5.6s7 2 7 5.6'></path></svg>";
function num(box){var c=box.querySelector('.t4s-count')||box;var t=(c.textContent||'').replace(/[^0-9]/g,'');return parseInt(t||'0',10)||0;}
function updateCounts(){var b=document.querySelectorAll('.t4s-site-nav__cart .t4s-count-box, .t4s-site-nav__heart .t4s-count-box');for(var i=0;i<b.length;i++){if(num(b[i])>0){b[i].classList.add('ss7-show-count');}else{b[i].classList.remove('ss7-show-count');}}}
function injectAccount(){var nav=document.querySelector('.t4s-site-nav__icons');if(!nav){return;}if(nav.querySelector('.ss7-account')){return;}var search=nav.querySelector('.t4s-site-nav__search');var w=document.createElement('div');w.className='t4s-site-nav__icon t4s-site-nav__account ss7-account';var a=document.createElement('a');a.className='t4s-pr';a.setAttribute('href','/account');a.setAttribute('aria-label','Account');a.innerHTML=SVG;w.appendChild(a);if(search&&search.parentNode===nav){search.insertAdjacentElement('afterend',w);}else{nav.appendChild(w);}}
function init(){injectAccount();updateCounts();var nav=document.querySelector('.t4s-site-nav__icons');if(nav){try{var mo=new MutationObserver(function(){updateCounts();});mo.observe(nav,{subtree:true,childList:true,characterData:true});}catch(e){}}document.addEventListener('cart:updated',updateCounts);document.addEventListener('cart:refresh',updateCounts);document.addEventListener('wishlist:updated',updateCounts);}
if(document.readyState!=='loading'){init();}else{document.addEventListener('DOMContentLoaded',init);}
})();

/* SS7: make the mobile search field more responsive.
   PURELY ADDITIVE — never calls preventDefault/stopPropagation, so it can't
   interfere with the theme opening the search panel.
   (a) when the search icon is tapped, focus the field within the same gesture so
       the keyboard appears automatically (no need to tap the field at all);
   (b) a tap anywhere inside the open search bar focuses the field, so you don't
       have to hit the input precisely. */
(function(){
  function field(){
    return document.querySelector('#t4s-search-hidden input[name="q"], #t4s-search-hidden .t4s-mini-search__input, #t4s-search-hidden input:not([type="hidden"]):not([type="submit"])');
  }
  function focusField(){
    var i=field();
    if(!i){return;}
    try{i.focus({preventScroll:true});}catch(e){try{i.focus();}catch(e2){}}
  }
  document.addEventListener('click',function(e){
    var t=e.target;
    if(!t||!t.closest){return;}
    /* (a) opened search via the icon -> auto-focus the field */
    if(t.closest('[data-toggle-class~="show-search"], .ss7-header-search-btn')){
      focusField();
      setTimeout(function(){
        if(document.body.classList.contains('show-search')){focusField();}
        else{var i=field();if(i){try{i.blur();}catch(e3){}}}
      },60);
      return;
    }
    /* (b) tapped inside the search bar (not a link/button) -> focus the field */
    var bar=t.closest('#t4s-search-hidden .t4s-mini-search__frm, #t4s-search-hidden .t4s-mini-search__btns');
    if(bar && !t.closest('a, button')){focusField();}
  },false);
})();
